module.exports = __webpack_public_path__ + "static/media/thought-background-2.d3cff6ff.svg";